export default "__VITE_ASSET__DlOPpLh5__"